module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.a1953558.png";